import { Share2, Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface LinkShareBadgeProps {
	// For links you own - shows count of users shared with
	shareCount?: number;

	// For links shared with you - shows who shared it
	sharedBy?: {
		username: string;
		display_name: string | null;
	};
	role?: 'editor' | 'viewer';

	className?: string;
}

export function LinkShareBadge({ shareCount, sharedBy, role, className }: LinkShareBadgeProps) {
	// Link is shared with others (you are owner)
	if (shareCount !== undefined && shareCount > 0) {
		return (
			<Badge variant="outline" className={className} title={`Shared with ${shareCount} user(s)`}>
				<Users className="size-3" />
				{shareCount}
			</Badge>
		);
	}

	// Link is shared with you (you are not owner)
	if (sharedBy) {
		const displayName = sharedBy.display_name || `@${sharedBy.username}`;
		const roleText = role === 'editor' ? 'Editor' : 'Viewer';

		return (
			<Badge
				variant="secondary"
				className={className}
				title={`Shared by ${displayName} as ${roleText}`}
			>
				<Share2 className="size-3" />
				by {displayName}
			</Badge>
		);
	}

	return null;
}
